import { PipeTransformPipe } from './../../shared/pipe/pipe-transform.pipe';
import { HttpClientService } from './../../shared/services/http-client.service';
import { Component, OnInit } from '@angular/core';
import { StripHtmlPipe } from '../../stripHtml';
import { CommonService } from '../../shared/services/common-service';
import { ApiEndpoints } from '../constant';

declare var $: any;

@Component({
  selector: 'app-tutorials',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.css']
})
export class TutorialsComponent implements OnInit {

  public tutorialVideos = [];
  public selectedVideo;
  public showLoader = true;
  public tutorialVideo;

  constructor(
    private httpClientService: HttpClientService,
    private pipeTransform: PipeTransformPipe,
    private commonService: CommonService, private striphtml: StripHtmlPipe,

  ) { }

  ngOnInit() {
    this.getVideoTutorials();
  }

  // getVideoTutorials() {
  //   // this.commonService.getwijayanews().then((response: any) => {
  //   //   this.wijayanews = response;
  //   // })
  //   this.tutorialVideos = [
  //     {
  //       title : "",
  //       description : "",
  //       videoUrl: "",
  //       imageURl: ""
  //     }
  //   ] 

  // }

  showVideo(video) {
    this.selectedVideo = video;
    this.tutorialVideo = this.pipeTransform.transform(video.videoUrl);
    $('#tutorialPopup').modal("show");
  }

  getVideoTutorials() {
    // if (this.tutorialVideos && this.tutorialVideos.length != 0) {
    //   return;
    // }
    // this.showLoader = true;
    // this.httpClientService.get(ApiEndpoints.tutorialList).subscribe(response => {
    //   if (response.items) {
    //     response.items.forEach(item => {
    //       this.tutorialVideos.push(
    //         {
    //           'videoUrl': ApiEndpoints.YOUTUBE_BASE_URL + item.snippet.resourceId.videoId,
    //           'title': item.snippet.title,
    //           'description': item.snippet.description,
    //           'thumbnails': item.snippet.thumbnails.medium.url
    //         });
    //     });

    //   }
    //   this.showLoader = false;
    // },
    //   error => {
    //     this.showLoader = false;
    //   }
    // );
    debugger
    window.open('https://www.youtube.com/playlist?list=PLgZ52NGg0ua9cVU1fl8ki_IzX1xj80w4b', '_blank');

  }

  public openNewTab(url: string) {
    window.open(url, '_blank');
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/tutorials/tutorial.component.ts